import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import { NCZIElectronicPrescriptionSignatureStatus } from '../../../Interfaces/ncziElectronicPrescriptionItem';

interface Props {
	status: NCZIElectronicPrescriptionSignatureStatus;
}

const ElectronicPrescriptionSignatureStatus: React.FC<Props> = props => {
	const { status } = props;

	const statusMap = {
		JePodpisanyPlatny:
			'nczi.electronicPrescription.detail.signature.signedValid',
		JePodpisanyNeplatny:
			'nczi.electronicPrescription.detail.signature.signedInvalid',
		JePodpisanyNeovereny:
			'nczi.electronicPrescription.detail.signature.signedNotCheck',
		NieJePodpisany: 'nczi.electronicPrescription.detail.signature.notSigned',
	};

	return <Text tx={statusMap[status]} />;
};

export default ElectronicPrescriptionSignatureStatus;
